import { render, staticRenderFns } from "./MatterMatterInfoForm.vue?vue&type=template&id=151e535a&"
import script from "./MatterMatterInfoForm.vue?vue&type=script&lang=js&"
export * from "./MatterMatterInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports